import { render } from "./AlbumScore.vue?vue&type=template&id=6817f179"
import script from "./AlbumScore.vue?vue&type=script&lang=js"
export * from "./AlbumScore.vue?vue&type=script&lang=js"

import "./AlbumScore.vue?vue&type=style&index=0&id=6817f179&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__